import intl from 'react-intl-universal';
import { history } from '@umijs/max';
import { Dropdown, Space } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import Logout from '../Logout';
import PageTabs from '../PageTabs';
import styles from './index.less';
import logo from '@/assets/logo@2x.png';
import css from '@/assets/css.png';
import gss from '@/assets/gss-logo.png';
import ReceiveStatus from '../ReceiveStatus';
import SelectCountry from './components/SelectCountry';
import { isGlobalEnv } from '@/config';
import SoftPhone from '../SoftPhone';
import Sms from '../Sms';
import OpenCallPage from '../SoftPhone/components/openCallPage';

const LayoutHeader = () => {
    // 跳转到首页
    const gotoHome = () => {
        history.push('/index');
    };

    return (
        <div className={styles.layoutHeader}>
            <div
                className={styles.logoTitle}
                onClick={gotoHome}
            >
                <img
                    height={26}
                    src={logo}
                />

                <img
                    height={26}
                    src={isGlobalEnv ? gss : css}
                />

                {/* <h1>服务系统</h1> */}
            </div>
            {!isGlobalEnv && (
                <div className={styles.utils_contianer}>
                    <div className={styles.top}>
                        <div className={styles.topLeft}>
                            <SoftPhone />
                            <Sms />
                        </div>

                        <Space className={styles.receiveStatusLogout}>
                            <Dropdown
                                placement="bottomCenter"
                                arrow
                                menu={{
                                    items: [
                                        {
                                            key: '1',
                                            label: <ReceiveStatus />,
                                        },
                                        {
                                            key: '2',
                                            label: <OpenCallPage />,
                                        },
                                    ],
                                }}
                            >
                                <div style={{ cursor: 'pointer' }}>
                                    <CaretDownOutlined />
                                    {intl.get('常用工具')}
                                </div>
                            </Dropdown>
                            {/* {!isGlobalEnv && <ReceiveStatus />} */}
                            <Logout />
                        </Space>
                    </div>
                    <div className={styles.bottom}>
                        <div className={styles.tabs}>
                            <PageTabs />
                        </div>
                    </div>
                </div>
            )}

            {isGlobalEnv && (
                <div className={styles.tabs}>
                    <PageTabs />
                </div>
            )}
            {isGlobalEnv && (
                <div className={styles.receiveStatusLogout}>
                    <SelectCountry />
                    <Logout />
                </div>
            )}
        </div>
    );
};

export default LayoutHeader;
